import DrawCards from '../cards/draw-cards'
import DrawCardsMobile from '@/components/entity/draw/cards-mobile'
import LayoutWithSidebar from '@/components/entity/draw/layout/layout-with-sidebar'
import styles from './styles.module.css'
import Paragraph from '@/components/ui/paragraph'
import { useTranslation } from 'next-i18next'
import DrawLinks from '../links'

const DrawLayout = ({ children, openInstruction, openCharity }) => {
  const { t } = useTranslation('draw')
  const paragraph = { title: t('draw::paragraph::title'), text: t('draw::paragraph::text') }

  return (
    <LayoutWithSidebar>
      <div className={styles.drawCardsWrapper}>
        <DrawCards />
      </div>
      <DrawCardsMobile />
      <div className={styles.drawParagraph}>
        <Paragraph {...paragraph} />
      </div>
      {children}
      <div className={styles.drawLinks}>
        <DrawLinks openInstruction={openInstruction} openCharity={openCharity} />
      </div>
    </LayoutWithSidebar>
  )
}

export default DrawLayout
